import React, { useState, useEffect } from 'react';
import './BackgroundChanger.css';

const images = [
  { url: 'image1.webp'},
  { url: 'image2.webp'},
];

const BackgroundChanger = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentImageIndex(prevIndex => (prevIndex + 1) % images.length);
        setFade(true);
      }, 500); // Doba trvání přechodu
    }, 5000); // Změna obrázku každých 5 sekund

    return () => clearInterval(intervalId); // Vyčištění intervalu při odmountování komponenty
  }, []);

  const currentImage = images[currentImageIndex];

  return (
    <div className={`background-changer ${fade ? 'fade-in' : 'fade-out'}`} style={{ backgroundImage: `url(${currentImage.url})` }}>
      <div className="content">
      </div>
    </div>
  );
};

export default BackgroundChanger;